
import { Options, Vue } from 'vue-class-component';
import { mapState, mapActions } from 'vuex';
// Components
import QuizComponent from '@/components/shared/QuizComponent.vue';

@Options({
  components: { QuizComponent },
  computed: {
    ...mapState(['isLogged', 'quizzes']),
  },
  methods: mapActions(['getAllQuizes']),
})
export default class Home extends Vue {
  isLogged!: boolean;

  getAllQuizes!: () => Promise<void>;

  mounted(): void {
    if (!this.isLogged) {
      this.$router.push({ name: 'Introduction' });
    }
    this.getAllQuizes();
  }
}
